import { render, staticRenderFns } from "./PmtClmResCatPerBusCls.vue?vue&type=template&id=71528916&"
import script from "./PmtClmResCatPerBusCls.vue?vue&type=script&lang=js&"
export * from "./PmtClmResCatPerBusCls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports